import { render } from "./sic_industry.vue?vue&type=template&id=48aa269f&lang=html"
import script from "./sic_industry.vue?vue&type=script&lang=js"
export * from "./sic_industry.vue?vue&type=script&lang=js"

import "./sic_industry.vue?vue&type=style&index=0&id=48aa269f&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__